module.exports = __webpack_public_path__ + "img/xls.07e9e00f.svg";